import {Injectable} from '@angular/core';
import {Bookmark} from './ts/bookmark';
import {BookmarkType} from './ts/enum/bookmark-type';
import {LoggerService} from './logger.service';

@Injectable({
    providedIn: 'root'
})
export class FeedParserService {

    constructor(private a: LoggerService) {

    }

    private c = (a: any, b: any) => {
        const c = a.title.toUpperCase(),
            d = b.title.toUpperCase(),
            e = a.type,
            f = b.type;
        let g = 0;
        return e === f ? c > d ? g = 1 : d > c && (g = -1) : g = 'RemoteApp' === f ? 1 : -1, g;
    };

    private getAttr(el: Element, name: string): string {
        return el.getAttribute(name) ?? '';
    }

    private asArray(nodeList: NodeListOf<Element> | null): Element[] {
        return nodeList ? Array.from(nodeList) : [];
    }

    parseWorkspaceFeed(b: any): WebFeed {
        const parser = new DOMParser();
        const doc = parser.parseFromString(b, 'text/xml');
        const publisherEl = doc.querySelector('ResourceCollection > Publisher')!;
        const f: WebFeed = {
            publisher: this.getAttr(publisherEl, 'Name'),
            publisherId: this.getAttr(publisherEl, 'ID'),
            bookmarks: [],
            folders: [],
            url: null,
            description: this.getAttr(publisherEl, 'Description'),
            supportInfoPresent: !1,
            supportObj: {
                logoURL: null,
                supportURL: null,
                supportPhone: null,
                privacyURL: null
            }
        };
        let g = f.description;
        const h = g.indexOf('{');
        if (h >= 0 && (f.description = g.substr(0, h), g = g.substr(h), g = g.trim(), g.search('{*}'))) {
            try {
                f.supportObj = JSON.parse(g), f.supportInfoPresent = !0;
            } catch (_b) {
                f.supportObj = null, this.a.log('Error in reading the following support information JSON : ' + g);
            }
        }
        let i;
        const resources = this.asArray(publisherEl.querySelectorAll('Resources > Resource'));
        const j = resources.map(el => ({
            el,
            title: this.getAttr(el, 'Title'),
            type: this.getAttr(el, 'Type'),
            id: this.getAttr(el, 'ID'),
            icon32Url: this.getAttr(el.querySelector('Icons > Icon32')!, 'FileURL'),
            rdpFileUrl: this.getAttr(el.querySelector('HostingTerminalServers > HostingTerminalServer > ResourceFile')!, 'URL'),
            folderEls: this.asArray(el.querySelectorAll('Folders > Folder'))
        }));
        j.sort(this.c);
        let k, l, n;
        for (k = 0; k < j.length; k++) {
            const res = j[k];
            i = new Bookmark;
            i.id = res.id;
            i.friendlyName = res.title;
            i.thumbnail = res.icon32Url;
            i.rdpFileURL = res.rdpFileUrl;
            i.workspaceName = f.publisher;
            i.bookmarkType = 'RemoteApp' === res.type ? BookmarkType.RemoteApp : BookmarkType.Desktop;
            if (res.folderEls.length > 0) {
                for (l = 0; l < res.folderEls.length; l++) {
                    n = this.getAttr(res.folderEls[l], 'Name');
                    '/' === n[0] && n.length > 1 && (n = n.substr(1));
                    f.folders.indexOf(n) < 0 && '/' !== n && f.folders.push(n);
                    i.folderNames.push(n);
                }
            }
            f.bookmarks.push(i);
        }
        return f.folders.sort((a, bb) => a.localeCompare(bb)), f;
    }
}

export class WebFeed {
    publisher!: any;
    publisherId!: any;
    bookmarks!: Bookmark[];
    folders!: any[];
    url!: any;
    description!: any;
    supportInfoPresent!: boolean;
    supportObj!: WebFeedSupportObj | null;
}

export class WebFeedSupportObj {
    logoURL!: any;
    supportURL!: any;
    supportPhone!: any;
    privacyURL!: any;
}
